import React from 'react'
import Header from '../Components/Header/Header'
import LandingPage from '../Components/LandingPage/LandingPage'

const home = () => {
  return (
    <div>
      <Header />
      <LandingPage/>
    </div>
  )
}

export default home